import React from "react";

// Common in-app webviews, plus Firefox, which downloads a multi-pass .pkpasses
// bundle instead of opening Wallet (mozilla-mobile/firefox-ios#24655). Chrome and
// Edge on iOS add passes fine, so they get no hint. A plain WKWebView leaves the
// "Safari/" token off its user agent, so that's caught too.
const NEEDS_SAFARI_IOS = /FxiOS|GSA\/|FBAN|FBAV|Instagram|LinkedInApp|Line\/|Twitter|MicroMessenger/;

export const APPLE_WALLET_SAFARI_HINT = "Having trouble? Open this page in Safari to add to Apple Wallet.";

// A hint only: the Wallet link stays put whatever this returns. iPadOS reports a
// Macintosh user agent, so iPad webviews get no hint.
export const needsSafariForWallet = (userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent) => {
  if (!/iPhone|iPad|iPod/.test(userAgent)) return false;

  return NEEDS_SAFARI_IOS.test(userAgent) || !/Safari\//.test(userAgent);
};

const AppleWalletSafariHint = ({ className, userAgent }) => {
  if (!needsSafariForWallet(userAgent)) return null;

  return (
    <p className={["apple-wallet-safari-hint small text-muted mb-0", className].filter(Boolean).join(" ")}>
      {APPLE_WALLET_SAFARI_HINT}
    </p>
  );
};

export default AppleWalletSafariHint;
